import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const card = { background: 'white', border: '1px solid #d8e4dd', borderRadius: '8px', padding: '16px', boxShadow: '0 12px 30px rgba(24,47,38,0.08)' };
const muted = { color: '#61726b', fontSize: '13px' };

function euro(value) {
  return Number(value || 0).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
}

function color(priority) {
  return priority === 'hoch' ? '#b42318' : '#a16207';
}

export default function AnomaliesPage() {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [filter, setFilter] = useState('all');
  const [error, setError] = useState('');

  useEffect(() => { load(); }, []);

  async function load() {
    setError('');
    try {
      const r = await api.get('/anomalies/radar');
      setData(r.data);
    } catch (e) {
      setError(e.response?.data?.error || e.message || 'Anomalien konnten nicht geladen werden');
    }
  }

  const anomalies = data?.anomalies || [];
  const filtered = useMemo(() => anomalies.filter(a => filter === 'all' || a.typ === filter || a.prioritaet === filter), [anomalies, filter]);
  const totals = data?.totals || {};

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', alignItems: 'flex-start', marginBottom: '14px' }}>
        <div>
          <h1 style={{ margin: 0, color: '#064734', fontSize: '25px' }}>Anomalie-Radar</h1>
          <p style={{ ...muted, margin: '4px 0 0' }}>Neue Empfänger, Ausreißer, mögliche Dubletten und Kategorie-Sprünge.</p>
        </div>
        <button onClick={load} style={button('#334155')}>Aktualisieren</button>
      </div>

      {error && <Notice>{error}</Notice>}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: '10px', marginBottom: '12px' }}>
        <Stat title="Auffälligkeiten" value={totals.gesamt || 0} hint={data?.monat || '-'} tone="blue" />
        <Stat title="Hohe Priorität" value={totals.hoch || 0} hint="sofort ansehen" tone="red" />
        <Stat title="Neue Empfänger" value={totals.neuer_empfaenger || 0} hint="im aktuellen Monat" tone="amber" />
        <Stat title="Dublettenkandidaten" value={totals.moegliche_dublette || 0} hint="gleicher Tag/Betrag" tone="red" />
      </div>

      <section style={{ ...card, marginBottom: '12px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '10px', alignItems: 'center' }}>
          <div>
            <h2 style={h2}>Filter</h2>
            <p style={{ ...muted, margin: '4px 0 0' }}>Die Erkennung ist lesend und verändert keine Buchungen.</p>
          </div>
          <select value={filter} onChange={e => setFilter(e.target.value)} style={input}>
            <option value="all">Alle</option>
            <option value="hoch">Hohe Priorität</option>
            <option value="neuer_empfaenger">Neue Empfänger</option>
            <option value="betrag_ausreisser">Betragsausreißer</option>
            <option value="moegliche_dublette">Mögliche Dubletten</option>
            <option value="kategorie_sprung">Kategorie-Sprünge</option>
          </select>
        </div>
      </section>

      <div style={{ display: 'grid', gap: '12px' }}>
        {filtered.map((item, idx) => (
          <article key={`${item.typ}-${item.titel}-${idx}`} style={{ ...card, borderColor: color(item.prioritaet) }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '12px', alignItems: 'start' }}>
              <div>
                <h2 style={{ margin: 0, color: '#12231d', fontSize: '18px' }}>{item.titel}</h2>
                <p style={{ ...muted, margin: '4px 0 0' }}>{item.typ} - {item.kategorie} - {item.datum}</p>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ color: color(item.prioritaet), fontSize: '20px', fontWeight: 950 }}>{euro(item.betrag)}</div>
                <div style={muted}>{item.prioritaet}</div>
              </div>
            </div>
            <p style={{ color: '#334155', fontWeight: 800 }}>{item.text}</p>
            <button onClick={() => nav(item.detail_url)} style={button('#064734')}>Details prüfen</button>
          </article>
        ))}
        {!filtered.length && <div style={card}>Keine Auffälligkeiten für diesen Filter.</div>}
      </div>
    </div>
  );
}

function Stat({ title, value, hint, tone = 'slate' }) {
  const colors = { blue: '#1d4ed8', red: '#b42318', amber: '#a16207', slate: '#12231d' };
  return <div style={card}><div style={{ color: '#61726b', fontSize: '11px', fontWeight: 900, textTransform: 'uppercase' }}>{title}</div><div style={{ color: colors[tone] || colors.slate, fontSize: '24px', fontWeight: 950, marginTop: '6px' }}>{value}</div><div style={{ ...muted, marginTop: '3px' }}>{hint}</div></div>;
}

function Notice({ children }) {
  return <div style={{ background: '#fff1ef', color: '#9f1d12', border: '1px solid #ffc9c2', borderRadius: '8px', padding: '10px 12px', marginBottom: '12px', fontWeight: 800 }}>{children}</div>;
}

const h2 = { margin: 0, color: '#064734', fontSize: '17px' };
const input = { border: '1px solid #d8e4dd', borderRadius: '8px', padding: '10px 11px', background: 'white', color: '#12231d', fontWeight: 800 };
function button(bg) {
  return { background: bg, color: 'white', border: 'none', borderRadius: '8px', padding: '9px 11px', cursor: 'pointer', fontWeight: 900 };
}
